import { ObjectUtils } from 'record-it-utils/utils/ObjectUtils/ObjectUtils';
import { TupleArray } from './utilityTypes';
export function prepareProps<TProps extends Record<string, any>, TIgnoreChildren extends IgnoreChildren = undefined, TFilter extends FilterType<TProps> = Array<never>>(options: PreparePropsOptions<TProps, TIgnoreChildren, TFilter>): PreparePropsResult<TProps, TIgnoreChildren, TFilter> {
  const copy = {
    ...options.props
  };
  if (options.ignoreChildren && 'children' in copy) {
    // eslint-disable-next-line no-console
    console.warn("this component doesn't support children");
    delete (copy as any).children;
  }
  return ObjectUtils.omit(copy, (options.filter ?? []) as any) as any;
}
type IgnoreChildren = true | false | undefined;
type PreparePropsOptions<TProps, TIgnoreChildren extends IgnoreChildren, TFilter extends FilterType<TProps>> = Readonly<{
  ignoreChildren?: TIgnoreChildren;
  props: TProps;
  filter?: TupleArray<TFilter>;
}>;
type PreparePropsResult<TProps, TIgnoreChildren extends IgnoreChildren, TFilter extends FilterType<TProps>> = IgnoreChildrenHelper<FilterPropsHelper<TProps, TFilter>, TIgnoreChildren>;
type IgnoreChildrenHelper<TProps, TIgnoreChildren extends IgnoreChildren> = TIgnoreChildren extends true ? Omit<TProps, 'children'> : TProps;
type FilterPropsHelper<TProps, TFilter extends FilterType<TProps>> = Omit<TProps, TFilter[number]>;
type FilterType<TProps> = Array<Exclude<keyof TProps, 'children'>>;